var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MShoppingListRemoveModal modal-card-body"},[_c('p',{staticClass:"remove-message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('b-button',{staticClass:"is-primary",attrs:{"loading":_vm.loading},on:{"click":_vm.removeAddedItem}},[_vm._v(" "+_vm._s(_vm.$t('dict.remove'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }